module.exports = __webpack_public_path__ + "static/img/biddingbg.516dc25.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bidding/biddingbg.png
// module id = KVD3
// module chunks = 0